import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Auth } from '@freelancer/auth';
import { Datastore, DatastoreDocument, toNumber } from '@freelancer/datastore';
import { CardSize } from '@freelancer/ui/card';
import { HeadingColor, HeadingSize, HeadingType } from '@freelancer/ui/heading';
import * as Rx from 'rxjs';
import { map } from 'rxjs/operators';
import { HireMeUser } from '../hire-me.component';

@Component({
  template: `
    <fl-card
      *ngIf="hireMeUser$ | async as hireMeUser"
      class="DarkCard"
      [edgeToEdge]="true"
      [size]="CardSize.SMALL"
    >
      <fl-bit class="CardBackground">
        <fl-heading
          class="CardHeading PaddedSection"
          i18n="User Profile Hire Me Component Heading"
          [color]="HeadingColor.LIGHT"
          [headingType]="HeadingType.H2"
          [size]="HeadingSize.XXSMALL"
        >
          Hire for Work Opportunity
        </fl-heading>

        <fl-bit class="PaddedSection">
          <app-hire-me
            flTrackingSection="UserProfileHireMeModal"
            defaultMessage="Hi {{
              hireMeUser.profileUserDisplayName
            }}, I noticed your profile and would like to offer you my project. We can discuss any details over chat."
            i18n-defaultMessage="User Profile Hire Me module default message"
            [isResponsive]="true"
            [hireMeUser]="hireMeUser"
          ></app-hire-me>
        </fl-bit>
      </fl-bit>
    </fl-card>
  `,
  styleUrls: ['./hire-me-webapp-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HireMeWebappModalComponent implements OnInit {
  HeadingColor = HeadingColor;
  HeadingType = HeadingType;
  HeadingSize = HeadingSize;
  CardSize = CardSize;

  @Input() profileUserId: number;
  hireMeUser$: Rx.Observable<HireMeUser>;
  profileViewUsersDocument: DatastoreDocument<'profileViewUsers'>;

  constructor(private auth: Auth, private datastore: Datastore) {}

  ngOnInit(): void {
    this.profileViewUsersDocument = this.datastore.document(
      'profileViewUsers',
      this.profileUserId,
    );

    const usersDoc = this.datastore.document('users', this.auth.getUserId());

    const loggedUserHasProjects$ = this.datastore
      .collection('projects', query =>
        query
          .where(
            'ownerId',
            '==',
            this.auth.getUserId().pipe(map(id => toNumber(id))),
          )
          .limit(1),
      )
      .valueChanges()
      .pipe(map(projects => projects.length > 0));

    this.hireMeUser$ = Rx.combineLatest([
      this.profileViewUsersDocument.valueChanges(),
      usersDoc.valueChanges(),
      loggedUserHasProjects$,
    ]).pipe(
      map(([profileUser, loggedInUser, loggedUserHasProjects]) => ({
        authId: loggedInUser.id,
        profileUserId: profileUser.id,
        enterpriseIds: profileUser.enterpriseIds,
        profileUserDisplayName: profileUser.publicName || profileUser.username,
        paymentVerified: loggedInUser.status
          ? loggedInUser.status.paymentVerified
          : false,
        emailVerified: loggedInUser.status
          ? loggedInUser.status.emailVerified
          : false,
        defaultCurrency: loggedInUser.currency,
        loggedUserIsRookie: !loggedUserHasProjects,
      })),
    );
  }
}
